import React, { useEffect } from 'react';
import '../fonts/fonts.css';
import './particles.css';
import './about.css';
import Header from './header';
import grainGif from '../images/grain.gif';
import currentPFP from '../images/currentPFP.png';

function About({ isLoggedIn, onLogout, onLogin }) {
  useEffect(() => {
    // Particles.js initialization
    if (window.particlesJS) {
      // Initialize particles here if needed
    }
  }, []);

  return (
    <>
      <div className="grain-background" style={{ backgroundImage: `url(${grainGif})` }}></div>
      <Header isLoggedIn={isLoggedIn} onLogout={onLogout} onLogin={onLogin} />

      <p className="bingy"></p>
      <img className="aboutFace" src={currentPFP} alt="Logo" title="Albumify Logo" />
      <p id="particles-js"></p>
      <h2 className="bodyText">
        I'm a dedicated and motivated student with a strong academic record, currently pursuing an internship in Computer Science. 
        I have a high school diploma and have also obtained a lot of volunteer experience including Roadside Cleanup, Feed my Starving Children, 
        as well as my Eagle Scout Project. Also, I have significant work experience in various roles at Home Depot, including Lot Associate, 
        Cashier, and Service Desk Associate. I demonstrate leadership skills as a Senior Patrol Leader for Boy Scouts of America and am a 
        member of several student organizations at Iowa State University.
      </h2>
    </>
  );
}

export default About;

